import { render, staticRenderFns } from "./ActivityResultType.vue?vue&type=template&id=07b490f8&"
import script from "./ActivityResultType.vue?vue&type=script&lang=js&"
export * from "./ActivityResultType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports